<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. The Factory</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Peleg Walker</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Legend</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. My Obsession with Ramtail</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Ramtail or Round Farm?</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Ramtail Today</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Ghosts of Ramtail</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Other Local Haunts</span></p>
<p class="toc1"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/appendix" title="Link target outside of Sample">Appendix. A Brief Chronological History of Peleg Walker and the Ramtail Factory</span></p>
<p class="toc"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8553a2ca